import { mapActions } from 'vuex'
import { axiosGet } from '../axios/axios.js'
import { EventBus } from '../EventBus/EventBus.js'
import { bindTechnologicalOperationsRequiredFlags } from '../forms/Request/Request.js'

export const commonData = {
  data: function () {
    return {
      numberOfPendingRequestsToServer: 0
    }
  },
  watch: {
    numberOfPendingRequestsToServer: function (result) {
      if (result == 0) {
        this.$emit('initialized')
      }
    }
  },
  methods: {
    ...mapActions({
      setRequestDeliveryVISes: 'setRequestDeliveryVISes',
      setRequestTypes: 'setRequestTypes',
      setRequestPriorityConditions: 'setRequestPriorityConditions',
      setWorkTypes: 'setWorkTypes',
      setRequestSources: 'setRequestSources',
      setStocks: 'setStocks',
      setTaskStatesColors: 'setTaskStatesColors',
      setRequestTypesColors: 'setRequestTypesColors',
      setRequestTypesTextColors: 'setRequestTypesTextColors',
      setReportStateColors: 'setReportStateColors',
      setReportStateTextColors: 'setReportStateTextColors',
      setSelectedWorkAreas: 'setSelectedWorkAreas',
      setWorkShifts: 'setWorkShifts',
      setWorkShiftsColors: 'setWorkShiftsColors',
      setWorkShiftsFontColors: 'setWorkShiftsFontColors',
      setCustomWorkShiftColor: 'setCustomWorkShiftColor',
      setCustomWorkShiftFontColor: 'setCustomWorkShiftFontColor',
      setRoles: 'setRoles'
    }),
    prepareCommonData: function (additionalRequestsNumber = 0) {
      this.numberOfPendingRequestsToServer = 16 + additionalRequestsNumber

      this.updateRequestTypes().finally(() => this.numberOfPendingRequestsToServer--)
      EventBus.$on('update-request-types', this.updateRequestTypes)

      this.updateWorkTypes().finally(() => this.numberOfPendingRequestsToServer--)
      EventBus.$on('update-work-types', this.updateWorkTypes)

      axiosGet({
        url: '/service/obj/search?type=requestSource&subtypes=true&limit=10000',
        onSuccess: (response) => {
          this.setRequestSources(response.data.result)
        },
        onFailure: 'Ошибка получения списка возможных источников данных заявки'
      }).finally(() => this.numberOfPendingRequestsToServer--)

      axiosGet({
        url: '/service/obj/search?type=SourceVIS&subtypes=true&limit=10000',
        onSuccess: (response) => {
          this.setRequestDeliveryVISes(response.data.result)
        },
        onFailure: 'Ошибка получения списка возможных источников, передавших заявку',
        msgTarget: this
      }).finally(() => this.numberOfPendingRequestsToServer--)

      axiosGet({
        url: '/service/obj/search?type=priorityCondition&subtypes=true&limit=10000',
        onSuccess: (response) => {
          this.setRequestPriorityConditions(response.data.result)
        },
        onFailure: 'Ошибка получения списка особых условий'
      }).finally(() => this.numberOfPendingRequestsToServer--)

      axiosGet({
        url: '/service/delta/report/stocks',
        onSuccess: (response) => {
          this.setStocks(response.data.result)
        },
        onFailure: 'Ошибка получения списка складов'
      }).finally(() => this.numberOfPendingRequestsToServer--)

      this.prepareColorSchemes()
        .finally(() => {
          this.numberOfPendingRequestsToServer -= 5
        })

      axiosGet({
        url: '/service/delta/dispatcher/getfilter?type=common',
        onSuccess: (response) => {
          this.setSelectedWorkAreas(response.data.workArea.values)
        },
        onFailure: 'Ошибка получения направлений работ',
        msgTarget: this
      }).finally(() => this.numberOfPendingRequestsToServer--)

      axiosGet({
        url: '/service/delta/access/roles',
        onSuccess: (response) => {
          this.setRoles(response.data)
        },
        onFailure: 'Ошибка получения спика доступных ролей',
        msgTarget: this
      }).finally(() => this.numberOfPendingRequestsToServer--)

      axiosGet({
        url: '/service/obj/search?type=workShift&returnFields=key,name&add=startHour,endHour,shortName,wsType,active&nolabels=external',
        onSuccess: (response) => {
          const workShifts = response.data.result
          workShifts.forEach(ws => {
            ws._disabled = !ws.active
            ws.disable = !ws.active
          })
          this.setWorkShifts(workShifts)

          axiosGet({
            url: '/service/settings/map?folder=workshiftColor',
            onSuccess: (response) => {
              const colors = response.data
              this.setWorkShiftsColors(colors)
              this.setCustomWorkShiftColor(colors['brigadier.custom'])
            },
            onFailure: 'Ошибка получения цветов смен',
            msgTarget: this
          }).finally(() => this.numberOfPendingRequestsToServer--)

          axiosGet({
            url: '/service/settings/map?folder=workshiftFontColor',
            onSuccess: (response) => {
              const fontColors = response.data
              this.setWorkShiftsFontColors(fontColors)
              this.setCustomWorkShiftFontColor(fontColors['font.brigadier.custom'])
            },
            onFailure: 'Ошибка получения цветов текста смен',
            msgTarget: this
          }).finally(() => this.numberOfPendingRequestsToServer--)
        },
        onFailure: 'Ошибка получения списка смен',
        msgTarget: this
      }).finally(() => this.numberOfPendingRequestsToServer--)
    },
    prepareColorSchemes: function () {
      const promises = [
        axiosGet({
          url: '/service/settings/map?prefix=taskState.color.',
          onSuccess: response => {
            this.setTaskStatesColors(response.data || {})
          },
          onFailure: 'Ошибка получения цветовой схемы состояний БП'
        }),
        axiosGet({
          url: '/service/settings/map?prefix=requestType.color.',
          onSuccess: response => {
            this.setRequestTypesColors(response.data || {})
          },
          onFailure: 'Ошибка получения цветовой схемы типов заявок'
        }),
        axiosGet({
          url: '/service/settings/map?prefix=requestType.textColor.',
          onSuccess: response => {
            this.setRequestTypesTextColors(response.data || {})
          },
          onFailure: 'Ошибка получения цветовой схемы шрифтов типов заявок'
        }),
        axiosGet({
          url: '/service/settings/map?prefix=reportState.color.',
          onSuccess: response => {
            this.setReportStateColors(response.data || {})
          },
          onFailure: 'Ошибка загрузки цветовой схемы состояний отчётов'
        }),
        axiosGet({
          url: '/service/settings/map?prefix=reportState.colorText.',
          onSuccess: response => {
            this.setReportStateTextColors(response.data || {})
          },
          onFailure: 'Ошибка загрузки цветовой схемы шрифтов для состояний отчётов'
        })
      ]

      return Promise.all(promises)
    },
    updateRequestTypes: function () {
      return axiosGet({
        url: '/service/delta/request/getRequestTypes?all=true',
        onSuccess: (response) => {
          this.setRequestTypes(response.data.result)
        },
        onFailure: 'Ошибка получения списка возможных типов заявки'
      })
    },
    updateWorkTypes: function () {
      return axiosGet({
        url: '/service/delta/request/getWorkTypes?filter=common&all=true&includeWorkAreas=true&extendedResult=true',
        onSuccess: (response) => {
          bindTechnologicalOperationsRequiredFlags(response.data.result)
          this.setWorkTypes(response.data.result)
        },
        onFailure: 'Ошибка получения списка работ'
      })
    },

    destroyCommonData: function () {
      EventBus.$off('update-request-types', this.updateRequestTypes)
      EventBus.$off('update-work-types', this.updateWorkTypes)
    }
  }
}
